import { createAction } from 'redux-actions';

export const fetchUser = createAction('FETCH_USER');
export const fetchUserSuccess = createAction('FETCH_USER_SUCCESS');
export const fetchUserFailure = createAction('FETCH_USER_FAILURE');

export const fetchUserRoles = createAction('FETCH_USER_ROLES');
export const fetchUserRolesSuccess = createAction('FETCH_USER_ROLES_SUCCESS');
export const fetchUserRolesFailure = createAction('FETCH_USER_ROLES_FAILURE');

export const createUserRole = createAction('CREATE_USER_ROLES');
export const createUserRoleSuccess = createAction('CREATE_USER_ROLES_SUCCESS');
export const createUserRoleFailure = createAction('CREATE_USER_ROLES_FAILURE');

export const removeUserRole = createAction('REMOVE_USER_ROLES');
export const removeUserRoleSuccess = createAction('REMOVE_USER_ROLES_SUCCESS');
export const removeUserRoleFailure = createAction('REMOVE_USER_ROLES_FAILURE');

export const changeUserPassword = createAction('CHANGE_USER_PASSWORD');
export const changeUserPasswordSuccess = createAction('CHANGE_USER_PASSWORD_SUCCESS');
export const changeUserPasswordFailure = createAction('CHANGE_USER_PASSWORD_FAILURE');

export const createUser = createAction('CREATE_USER');
export const createUserSuccess = createAction('CREATE_USER_SUCCESS');
export const createUserFailure = createAction('CREATE_USER_FAILURE');

export const deleteUser = createAction('DELETE_USER');
export const deleteUserSuccess = createAction('DELETE_USER_SUCCESS');
export const deleteUserFailure = createAction('DELETE_USER_FAILURE');

export const updateUser = createAction('UPDATE_USER');
export const updateUserSuccess = createAction('UPDATE_USER_SUCCESS');
export const updateUserFailure = createAction('UPDATE_USER_FAILURE');

export const fetchUserOverrides = createAction('FETCH_USER_OVERRIDES');
export const fetchUserOverridesSuccess = createAction('FETCH_USER_OVERRIDES_SUCCESS');
export const fetchUserOverridesFailure = createAction('FETCH_USER_OVERRIDES_FAILURE');

export const createUserOverride = createAction('CREATE_USER_OVERRIDE');
export const createUserOverrideSuccess = createAction('CREATE_USER_OVERRIDE_SUCCESS');
export const createUserOverrideFailure = createAction('CREATE_USER_OVERRIDE_FAILURE');

export const deleteUserOverride = createAction('DELETE_USER_OVERRIDE');
export const deleteUserOverrideSuccess = createAction('DELETE_USER_OVERRIDE_SUCCESS');
export const deleteUserOverrideFailure = createAction('DELETE_USER_OVERRIDE_FAILURE');

export const fetchUserPolicies = createAction('FETCH_USER_POLICIES');
export const fetchUserPoliciesSuccess = createAction('FETCH_USER_POLICIES_SUCCESS');
export const fetchUserPoliciesFailure = createAction('FETCH_USER_POLICIES_FAILURE');

export function newUser() {
	const data = {
		enabled: true,
		createdOn: null
	};

	return {
		type: fetchUserSuccess,
		payload: data
	};
}
